import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PaymentElementFeatureState } from '../../types/payment-element/models';

/** Feature selector raíz */
export const selectPaymentElement =
  createFeatureSelector<PaymentElementFeatureState>('paymentElement');

/** Sub-slices */
export const selectOneTime = createSelector(
  selectPaymentElement,
  (s) => s.oneTime
);
export const selectRecurring = createSelector(
  selectPaymentElement,
  (s) => s.recurring
);

/** ONE-TIME fields */
export const selectOTContainerId = createSelector(
  selectOneTime,
  (s) => s.containerId
);
export const selectOTClientSecret = createSelector(
  selectOneTime,
  (s) => s.clientSecret
);
export const selectOTActive = createSelector(selectOneTime, (s) => s.active);
export const selectOTElementStatus = createSelector(
  selectOneTime,
  (s) => s.elementStatus
);
export const selectOTConfirmStatus = createSelector(
  selectOneTime,
  (s) => s.confirmStatus
);
export const selectOTIsReady = createSelector(
  selectOTElementStatus,
  (s) => s === 'mounted'
);
export const selectOTIsConfirming = createSelector(
  selectOTConfirmStatus,
  (s) => s === 'pending'
);

/** RECURRING fields */
export const selectRContainerId = createSelector(
  selectRecurring,
  (s) => s.containerId
);
export const selectRClientSecret = createSelector(
  selectRecurring,
  (s) => s.clientSecret
);
export const selectRActive = createSelector(selectRecurring, (s) => s.active);
export const selectRElementStatus = createSelector(
  selectRecurring,
  (s) => s.elementStatus
);
export const selectRConfirmStatus = createSelector(
  selectRecurring,
  (s) => s.confirmStatus
);
export const selectRIsReady = createSelector(
  selectRElementStatus,
  (s) => s === 'mounted'
);
export const selectRIsConfirming = createSelector(
  selectRConfirmStatus,
  (s) => s === 'pending'
);
